var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomLinks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.043 25.0573V22.0502M22.0502 19.043H25.0573M4.00717 7.01434H1M7.01434 1V4.00717",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3705 13.5075C25.6196 11.1954 25.6196 7.45108 23.3705 5.13901C21.3802 3.09292 18.2434 2.82693 15.9545 4.50881L15.8908 4.55383C15.3176 4.97532 15.1862 5.79375 15.5962 6.37893C16.0062 6.96411 16.8024 7.10324 17.3716 6.68175L17.4353 6.63674C18.7131 5.69963 20.4606 5.84695 21.5673 6.98866C22.8212 8.2777 22.8212 10.3647 21.5673 11.6537L17.1009 16.2533C15.847 17.5424 13.8169 17.5424 12.5629 16.2533C11.4523 15.1116 11.309 13.3152 12.2206 12.0057L12.2644 11.9402C12.6744 11.3509 12.539 10.5325 11.9698 10.1151C11.4006 9.69768 10.6004 9.83272 10.1944 10.4179L10.1506 10.4834C8.51058 12.8323 8.76933 16.0569 10.7597 18.103C13.0088 20.4151 16.6511 20.4151 18.9002 18.103L23.3705 13.5075ZM2.68682 12.5499C0.437727 14.862 0.437727 18.6063 2.68682 20.9184C4.67717 22.9645 7.81396 23.2305 10.1029 21.5486L10.1666 21.5036C10.7398 21.0821 10.8711 20.2636 10.4611 19.6785C10.0511 19.0933 9.25497 18.9542 8.68573 19.3756L8.62204 19.4207C7.34424 20.3578 5.59671 20.2104 4.49008 19.0687C3.23616 17.7756 3.23616 15.6886 4.49008 14.3996L8.95642 9.80407C10.2103 8.51504 12.2405 8.51504 13.4944 9.80407C14.605 10.9458 14.7483 12.7422 13.8368 14.0558L13.793 14.1213C13.383 14.7106 13.5183 15.529 14.0875 15.9464C14.6568 16.3638 15.4569 16.2288 15.8629 15.6436L15.9067 15.5781C17.5468 13.2251 17.288 10.0005 15.2977 7.95441C13.0486 5.64234 9.40624 5.64234 7.15714 7.95441L2.68682 12.5499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomLinks);
export default __webpack_public_path__ + "static/media/custom-links.dba1b8bcd73ccd3e6c0c9a64c3be3d34.svg";
export { ForwardRef as ReactComponent };